/* istanbul ignore file*/
import { createAction } from '@reduxjs/toolkit';

export const updateUserInformation = createAction(
  'user/UPDATE_USER_INFORMATION',
  (name: string, value: unknown) => ({
    payload: {
      name,
      value,
    },
  }),
);
